import { Box, Link } from '@material-ui/core';
import { Alert } from '@dev/ee-components';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { getPickedCampaign } from '@/store/campaigns/actions';
import { ApplicationState } from '@/store';
import { links } from '@/services/dictionaries/links';
import { isCustomBranding, isReseller } from '@/services/Secuirty';
import { isClickTrackingEnabled, isOpenTrackingEnabled, isLinkClickTrackingEnabled } from '../Overview/helperFunctions';

export const DisabledTrackingAlert = (): JSX.Element => {
    const { campaign } = useSelector(getPickedCampaign);
    const { AdvancedOptions, GeneralInfo } = useSelector((state: ApplicationState) => state.account);
    const isClicksTracked = isClickTrackingEnabled(campaign, AdvancedOptions);
    const isOpensTracked = isOpenTrackingEnabled(campaign, AdvancedOptions);
    const isLinkTracked = isLinkClickTrackingEnabled(AdvancedOptions);

    const { t } = useTranslation();

    if (
        !AdvancedOptions ||
        !campaign ||
        (isClicksTracked && isOpensTracked && (!GeneralInfo.IsTrusted || isLinkTracked))
    ) {
        return null;
    }

    const text = [
        {
            text: t('openandclicktrackingdisabled'),
            available: !isClicksTracked && !isOpensTracked,
        },
        {
            text: t('clicktrackingdisabled'),
            available: !isClicksTracked,
        },
        {
            text: t('opentrackingdisabled'),
            available: !isOpensTracked,
        },
        {
            text: t('trackclicksbylinkswasdisabled'),
            available: !isLinkTracked,
        },
    ].find((o) => o.available)?.text;

    return (
        <Box pt="4px">
            <Alert
                severity="warning"
                body={
                    <div>
                        {text}{' '}
                        {!isReseller() && !isCustomBranding() && (
                            <Link target="_blank" rel="noreferrer" href={links.trackingOpensAndClicks}>
                                {t('learnmoreabouttracking')}
                            </Link>
                        )}
                    </div>
                }
            />
        </Box>
    );
};
